/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import withRouter from 'src/shared/app/base/component/hoc/withRouter';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';
import { getUserFirstName } from '@braindate/domain/lib/user/util';
import {
  getGuidanceText,
  getGuidanceAction,
  getGuidanceDescription,
} from 'src/shared/app/market/guidance/settings/guidanceSettings';
import { getMembership } from 'src/shared/domain/membership/selector/membershipSelectors';
import { deleteGuidanceMarketPrompt } from 'src/shared/domain/membership/action/membershipActions';
import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';

import MarketPromptCardDumb from './MarketPromptCardDumb';

import type { NavigateFunction } from 'react-router';
type Props = {
  handleDismiss: () => void,
  icon?: React.Node,
  invitationCount?: number,
  route: string,
  guidanceLabel: string,
  // Self passed
  // $FlowIssue
  intl: intlShape,
  navigate: NavigateFunction,
};

const mapStateToProps = (state: Object, ownProps: Props): Object => {
  const { guidanceLabel, invitationCount, icon, intl } = ownProps;
  const user = getSelf(state);

  return {
    ...ownProps,
    icon,
    confirmCta: getGuidanceAction(guidanceLabel, intl),
    text: getGuidanceText(guidanceLabel, intl, {
      invitationCount,
    }),
    description: getGuidanceDescription(guidanceLabel, intl, {
      firstName: user && getUserFirstName(user),
      br: <br />,
    }),
    // merge
    membership: getMembership(state),
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { navigate, route, guidanceLabel }: Props,
): Object => {
  const { membership } = stateProps;

  return {
    ...stateProps,
    onClick() {
      navigate(route);
      dispatch(deleteGuidanceMarketPrompt(membership, guidanceLabel));
      trackGAEvent('Market', 'Click prompt', guidanceLabel);
    },
  };
};

export default compose(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(MarketPromptCardDumb);
